import { Injectable } from '@angular/core';
import Resources from '../../core/constants/resources';
import { CanActivate, Router } from '@angular/router';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WelcomeGuardService implements CanActivate {

  constructor(private router: Router) {
  }

  canActivate(): boolean {
    this.router.navigate(['business-energy']);
    return true;
  }
}
